import { ISettlementOrderInfo, ISettlementOrderParams } from '../../../types/air-splitting/bill-management/settlementOrder';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 账单管理 - 收款订单列表
 */
export async function querySettlementOrderList(param: ISettlementOrderParams) {
  let data = [] as ISettlementOrderInfo[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as ISettlementOrderParams;

  try {
    const { code, context, message } = await Http.post<{ data: ISettlementOrderInfo[]; total: number }>(`${hostUrl}/pay/settlement-order/page-list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ISettlementOrderInfo[]; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 账单管理 - 收款订单导出
 */
export async function exportSettlementOrder(param: ISettlementOrderParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/settlement-order/export`,
      param,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 分账管理- 凑单分账
 */
export async function querySettlementOrderListByChoose(param) {
  let data = [] as any;

  param = JSON.parse(JSON.stringify(param)) as any;

  try {
    const { code, context, message } = await Http.post<{any}>(`${hostUrl}/pay/settlement-order/list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [] as any;

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 查询收款来源列表和终端所属列表
 */
export async function queryRcptSourceAndTerminals(companyId?: number) {
  let rcptSourceList = [] as string[];
  let terminalBelongList = [] as string[];

  try {
    const { code, context, message } = await Http.get<{
      rcptSourceList: string[];
      terminalBelongList: string[];
    }>(
      `${hostUrl}/pay/receipt-order/query-rcpt-source-and-terminal-belong-list`,
      { companyId },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { rcptSourceList: rcptSourceListData, terminalBelongList: terminalBelongListData } = context || {} as {
        rcptSourceList: string[];
        terminalBelongList: string[];
      };

      rcptSourceList = rcptSourceListData || [];
      terminalBelongList = terminalBelongListData || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    rcptSourceList,
    terminalBelongList,
  };
}
